import script from "./ApiWidget.vue?vue&type=script&lang=js"
export * from "./ApiWidget.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__